<template>
  <div>
    <!-- 开始页面start -->
    <template v-if="activeDefinePage !== 'answerPageBackgroundPic'">
      <span class="el-title-span fw-bold">外观设置</span>
      <el-row v-for="(item, i) in uploadArr" :key="i" style="margin: 0 0 20px 10px">
        <span class="fs14">{{ item.type == 'Pc' ? '电脑版' : '手机版' }}背景设置</span>
        <!-- <img v-if="defineFormTheme[`${activeDefinePage}${item.type}`]" :src="defineFormTheme[`${activeDefinePage}${item.type}`]" style="width: 148px; height: 148px" /> -->
        <el-col>
          <upload-img
            :alreadyFile="defineFormTheme[`${activeDefinePage}${item.type}`]"
            listType="picture-card"
            :imgSize="item.maxSize"
            @uploadSuccess="(res) => uploadBgImgHandle(res, `${activeDefinePage}${item.type}`)"
            @removeSuccess="removeBgImgHandle(`${activeDefinePage}${item.type}`)"
          >
          </upload-img>
          <div v-for="(tip, idx) in item.bgImgRule" :key="idx" class="el-upload__tip">{{ tip }}</div>
          <div v-if="activeDefinePage == 'startPageBackgroundPic'" class="el-upload__tip">{{ item.clickTips }}</div>
        </el-col>
      </el-row>
      <el-row align="middle" type="flex" v-if="activeDefinePage === 'startPageBackgroundPic'">
        <el-col :span="10">
          <span class="fw-bold"
            >隐藏开始页<el-tooltip
              class="item"
              content="开启此属性，问卷发布后开始页面不展示，直接进入答题页"
              effect="dark"
              placement="top-start"
            >
              <i class="el-icon-question" /> </el-tooltip
          ></span>
        </el-col>
        <el-col :span="10">
          <el-switch v-model="defineFormTheme.isDisableStartPage" @change="handleSaveDefineFormTheme" />
        </el-col>
      </el-row>
    </template>
    <!-- 开始页面end -->
    <!-- 答题页面start -->
    <template v-if="activeDefinePage == 'answerPageBackgroundPic'">
      <span class="el-title-span fw-bold">logo设置</span>
      <el-row>
        <el-col v-for="(item, i) in uploadArr" :key="i" :style="{ marginBottom: item.type == 'Mobile' ? '20px' : '0' }">
          <span class="fs14">{{ item.type == 'Pc' ? '电脑版' : '手机版' }}</span>
          <div class="flex-center">
            <upload-img
              :alreadyFile="defineFormTheme[`${getAnswerPageLogoType(item.type)}`]"
              listType="picture-card"
              :imgSize="item.maxSize"
              @uploadSuccess="(res) => uploadBgImgHandle(res, getAnswerPageLogoType(item.type))"
              @removeSuccess="removeBgImgHandle(getAnswerPageLogoType(item.type))"
            >
            </upload-img>
            <div class="ml-15 flex-column">
              <span v-for="(tip, idx) in item.logoImgRule" :key="idx" class="el-upload__tip">{{ tip }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <span class="el-title-span fw-bold">背景</span>
      <el-row align="middle" type="flex" style="margin-bottom: 10px">
        <el-col :span="10">
          <span class="fs14">背景设置</span>
        </el-col>
        <el-col :span="24">
          <el-radio-group
            v-model="defineFormTheme.answerPageBackgroundType"
            size="mini"
            @change="backgroundChange"
            v-removeAriaHidden
          >
            <el-radio-button :label="0"> 图片 </el-radio-button>
            <el-radio-button :label="1"> 颜色 </el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row v-if="defineFormTheme.answerPageBackgroundType == 0">
        <el-col v-for="(item, i) in uploadArr" :key="i" :style="{ marginBottom: item.type == 'Mobile' ? '20px' : '0' }">
          <span class="fs14">{{ item.type == 'Pc' ? '电脑版' : '手机版' }}</span>
          <div class="flex-center">
            <upload-img
              :alreadyFile="defineFormTheme[`${activeDefinePage}${item.type}`]"
              listType="picture-card"
              :imgSize="item.maxSize"
              @uploadSuccess="(res) => uploadBgImgHandle(res, `${activeDefinePage}${item.type}`)"
              @removeSuccess="removeBgImgHandle(`${activeDefinePage}${item.type}`)"
            >
            </upload-img>
            <div class="ml-15 flex-column">
              <span v-for="(tip, idx) in item.bgImgRule" :key="idx" class="el-upload__tip">{{ tip }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="defineFormTheme.answerPageBackgroundType == 1" class="ml-10 mt-20">
        <el-col :span="10">
          <span class="fs14">选择颜色</span>
        </el-col>
        <el-col :span="12">
          <el-color-picker
            v-model="defineFormTheme.answerPageBackgroundColor"
            size="mini"
            @change="(val) => handleChangeColor(val, 'answerPageBackgroundColor')"
          />
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <span class="el-title-span fw-bold">题号设置</span>
      <el-row align="middle" type="flex" style="margin-bottom: 16px">
        <el-col :span="14">
          <span class="fs14">显示题号</span>
        </el-col>
        <el-col :span="10">
          <el-switch v-model="defineFormTheme.isShowItemQuestionNumber" @change="handleSaveDefineFormTheme" />
        </el-col>
      </el-row>
      <el-row v-if="defineFormTheme.isShowItemQuestionNumber" align="middle" type="flex" style="margin-bottom: 10px">
        <el-col :span="14">
          <span class="fs14">题号按顺序显示</span>
          <el-tooltip class="item" effect="dark" content="开启后，题号按自增序号显示如：1、2、3、4、5…" placement="top">
            <i class="el-icon-question" style="margin-left: 4px"></i>
          </el-tooltip>
        </el-col>
        <el-col :span="10">
          <el-switch v-model="defineFormTheme.showNumber" @change="handleSaveDefineFormTheme" />
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <span class="el-title-span fw-bold">进度条</span>
      <div class="el-color-picker-box mt-10">
        <span class="fs14 el-color-picker-title">进度条颜色</span>
        <el-color-picker
          v-model="defineFormTheme.progressBarColor"
          size="mini"
          @change="(val) => handleChangeColor(val, 'progressBarColor')"
        />
      </div>

      <el-divider></el-divider>
      <span class="el-title-span fw-bold">提交按钮</span>
      <el-row align="middle" type="flex" style="margin-bottom: 10px">
        <el-col :span="8">
          <span class="fs14"
            >隐藏按钮<el-tooltip
              class="item"
              content="开启此属性，问卷发布后隐藏按钮提交按钮不展示，用户无法提交问卷"
              effect="dark"
              placement="top-start"
            >
              <i class="el-icon-question" /> </el-tooltip
          ></span>
        </el-col>
        <el-col :span="10">
          <el-switch v-model="defineFormTheme.isDisableSubmitButton" @change="handleSaveDefineFormTheme" />
        </el-col>
      </el-row>
      <el-row align="middle" type="flex" style="margin-bottom: 10px">
        <el-col :span="10">
          <span class="fs14">按钮设置</span>
        </el-col>
        <el-col :span="24">
          <el-radio-group
            v-model="defineFormTheme.answerPageSubButtonType"
            size="mini"
            @change="answerPageSubButtonTypeChange"
            v-removeAriaHidden
          >
            <el-radio-button :label="0"> 图片 </el-radio-button>
            <el-radio-button :label="1"> 颜色 </el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row v-if="defineFormTheme.answerPageSubButtonType == 0">
        <el-col v-for="(item, i) in uploadArr" :key="i" style="margin-bottom: 20px">
          <span class="fs14">{{ item.type == 'Pc' ? '电脑版' : '手机版' }}</span>
          <div class="flex-center">
            <upload-img
              :alreadyFile="defineFormTheme[`${getSubButtonPic(item.type)}`]"
              listType="picture-card"
              :imgSize="item.maxSize"
              @uploadSuccess="(res) => uploadBgImgHandle(res, getSubButtonPic(item.type))"
              @removeSuccess="removeBgImgHandle(getSubButtonPic(item.type))"
            >
            </upload-img>
            <div class="ml-15 flex-column">
              <span v-for="(tip, idx) in item.btnImgRule" :key="idx" class="el-upload__tip">{{ tip }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <template v-if="defineFormTheme.answerPageSubButtonType == 1">
        <div class="el-color-picker-box mt-10">
          <span class="fs14 el-color-picker-title">按钮颜色</span>
          <el-color-picker
            v-model="defineFormTheme.answerPageSubButtonColor"
            size="mini"
            @change="(val) => handleChangeColor(val, 'answerPageSubButtonColor')"
          />
        </div>
        <div class="el-color-picker-box mt-10">
          <span class="fs14 el-color-picker-title">文字颜色</span>
          <el-color-picker
            v-model="defineFormTheme.answerPageSubTextColor"
            size="mini"
            @change="(val) => handleChangeColor(val, 'answerPageSubTextColor')"
          />
        </div>
      </template>
    </template>
    <!-- 答题页面end -->
  </div>
</template>

<script>
import { saveDefineThemeRequest } from '@/api/project/form'
import { uploadArr } from '../congif'
import UploadImg from '@/components/Upload/UploadImg.vue'

export default {
  name: 'DefineTheme',
  props: ['formKey', 'activeDefinePage'],
  components: { UploadImg },
  data() {
    return {
      // 自定义外观设置
      defineFormTheme: {
        formKey: '',
        startPageBackgroundPicMobile: '',
        startPageBackgroundPicPc: '',
        answerPageLogoMobile: '',
        answerPageLogoPc: '',
        answerPageBackgroundPicMobile: '',
        answerPageBackgroundPicPc: '',
        answerPageBackgroundColor: '',
        answerPageBackgroundType: 0,
        progressBarColor: '',
        answerPageSubButtonType: 0,
        answerPageSubButtonColor: '',
        answerPageSubTextColor: '',
        submitPagePicMobile: '',
        submitPagePicPc: '',
        enable: 1,
        isDisableStartPage: false, //是否禁用开始页面,false.不禁用 true.禁用
        isDisableSubmitButton: false,
        showNumber: false, // 显示问题行号
        isShowItemQuestionNumber: true // 是否展示问题题号
      },
      uploadArr
    }
  },
  methods: {
    backgroundChange() {
      this.defineFormTheme.answerPageBackgroundPicMobile = ''
      this.defineFormTheme.answerPageBackgroundPicPc = ''
      this.defineFormTheme.answerPageBackgroundColor = ''
      this.handleSaveDefineFormTheme()
    },
    answerPageSubButtonTypeChange() {
      this.defineFormTheme.answerPageSubButtonPicMobile = ''
      this.defineFormTheme.answerPageSubButtonPicPc = ''
      this.defineFormTheme.answerPageSubButtonColor = ''
      this.defineFormTheme.answerPageSubTextColor = ''
      this.handleSaveDefineFormTheme()
    },

    uploadBgImgHandle(response, type) {
      console.log({ response, type })
      this.defineFormTheme[type] = response[0].url
      this.handleSaveDefineFormTheme()
    },
    removeBgImgHandle(type) {
      this.defineFormTheme[type] = ''
      this.handleSaveDefineFormTheme()
    },
    handleChangeColor(val, key) {
      if (!val) this.defineFormTheme[key] = ''
      this.handleSaveDefineFormTheme()
    },
    activeStyleHandle(item) {
      this.activeStyle = item.key
      this.queryFormTheme()
    },
    cleanFormSave(key) {
      this.defineFormTheme[key] = ''
      this.handleSaveDefineFormTheme()
    },
    // 保存自定义外观
    handleSaveDefineFormTheme() {
      // 如果不显示题号，那么序号开关还原
      if (!this.defineFormTheme.isShowItemQuestionNumber) {
        this.defineFormTheme.showNumber = true
      }

      const { defineFormTheme, formKey } = this
      let params = { ...defineFormTheme, formKey }

      saveDefineThemeRequest(params).then(() => {
        this.$emit('save')
      })
    },
    // 回显设置数据
    queryFormDefineThemeStyle(style) {
      console.log({ style })
      this.defineFormTheme = style
    },
    getAnswerPageLogoType(type) {
      return type == 'Pc' ? 'answerPageLogoPc' : 'answerPageLogoMobile'
    },
    getSubmitPagePicType(type) {
      return type == 'Pc' ? 'submitPagePicPc' : 'submitPagePicMobile'
    },
    getSubButtonPic(type) {
      return type == 'Pc' ? 'answerPageSubButtonPicPc' : 'answerPageSubButtonPicMobile'
    }
  }
}
</script>

<style scoped>
.el-color-picker-box {
  display: flex;
  margin-bottom: 10px;
}
.el-color-picker-title {
  display: inline-block;
  margin-right: 50px;
}
::v-deep .el-upload--picture-card,
::v-deep .el-upload-list__item {
  /* margin: 10px; */
  width: 80px;
  height: 80px;
  line-height: 80px;
  font-size: 12px;
}
.el-title-span {
  display: inline-block;
  margin-bottom: 10px;
}
.file-list-wrapper {
  width: 95%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
